// FETCH ALL PROPERTIES FROM COMPACTING_DC DETAILS
export const FETCH_COMPACTING_DC_DETAILS_REQUEST = 'FETCH_COMPACTING_DC_DETAILS_REQUEST';
export const FETCH_COMPACTING_DC_DETAILS_SUCCESS = 'FETCH_COMPACTING_DC_DETAILS_SUCCESS';
export const FETCH_COMPACTING_DC_DETAILS_FAILURE = 'FETCH_COMPACTING_DC_DETAILS_FAILURE';

export const FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST = 'FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_REQUEST';
export const FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS = 'FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_SUCCESS';
export const FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE = 'FETCH_COMPACTING_DC_DETAILS_PROGRAM_LIST_FAILURE';

// FETCH ALL PROPERTIES FROM COMPACTING_DC DETAILS BY ID
export const FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST = 'FETCH_COMPACTING_DC_DETAILS_BY_ID_REQUEST';
export const FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS = 'FETCH_COMPACTING_DC_DETAILS_BY_ID_SUCCESS';
export const FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE = 'FETCH_COMPACTING_DC_DETAILS_BY_ID_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST = 'FETCH_GRN_NO_BY_COMPACTING_PO_REQUEST';
export const FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS = 'FETCH_GRN_NO_BY_COMPACTING_PO_SUCCESS';
export const FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE = 'FETCH_GRN_NO_BY_COMPACTING_PO_FAILURE';

export const FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST = 'FETCH_COMPACTING_DC_DETAILS_DC_NO_REQUEST';
export const FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS = 'FETCH_COMPACTING_DC_DETAILS_DC_NO_SUCCESS';
export const FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE = 'FETCH_COMPACTING_DC_DETAILS_DC_NO_FAILURE';

// CREATE PROPERTIES FOR COMPACTING_DC DETAILS
export const CREATE_COMPACTING_DC_DETAILS_REQUEST = 'CREATE_COMPACTING_DC_DETAILS_REQUEST';
export const CREATE_COMPACTING_DC_DETAILS_SUCCESS = 'CREATE_COMPACTING_DC_DETAILS_SUCCESS';
export const CREATE_COMPACTING_DC_DETAILS_FAILURE = 'CREATE_COMPACTING_DC_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPACTING_DC_DETAILS = 'CREATE_USER_FORM_COMPACTING_DC_DETAILS';

// UPDATE PROPERTIES FOR COMPACTING_DC DETAILS
export const UPDATE_COMPACTING_DC_DETAILS_REQUEST = 'UPDATE_COMPACTING_DC_DETAILS_REQUEST';
export const UPDATE_COMPACTING_DC_DETAILS_SUCCESS = 'UPDATE_COMPACTING_DC_DETAILS_SUCCESS';
export const UPDATE_COMPACTING_DC_DETAILS_FAILURE = 'UPDATE_COMPACTING_DC_DETAILS_FAILURE';

// FETCH SINGLE COMPACTING_DC_DETAILS
export const FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST = 'FETCH_SINGLE_COMPACTING_DC_DETAILS_REQUEST';
export const FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS = 'FETCH_SINGLE_COMPACTING_DC_DETAILS_SUCCESS';
export const FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE = 'FETCH_SINGLE_COMPACTING_DC_DETAILS_FAILURE';

// DELETE PROPERTIES FOR COMPACTING_DC DETAILS
export const DELETE_COMPACTING_DC_DETAILS_REQUEST = 'DELETE_COMPACTING_DC_DETAILS_REQUEST';
export const DELETE_COMPACTING_DC_DETAILS_SUCCESS = 'DELETE_COMPACTING_DC_DETAILS_SUCCESS';
export const DELETE_COMPACTING_DC_DETAILS_FAILURE = 'DELETE_COMPACTING_DC_DETAILS_FAILURE';

export const FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST = 'FETCH_COMPACTING_DC_PREVIOUS_LIST_REQUEST';
export const FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS = 'FETCH_COMPACTING_DC_PREVIOUS_LIST_SUCCESS';
export const FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE = 'FETCH_COMPACTING_DC_PREVIOUS_LIST_FAILURE';

// USERFORM RESET

export const COMPACTING_DC_DETAILS_USERFORM_RESET = 'COMPACTING_DC_DETAILS_USERFORM_RESET';

export const COMPACTING_RESET_SELECTED_ID = 'COMPACTING_RESET_SELECTED_ID';

export const COMPACTING_DC_PROGRAM_ID_REQUEST = 'COMPACTING_DC_PROGRAM_ID_REQUEST';
export const COMPACTING_DC_PROGRAM_ID_SUCCESS = 'COMPACTING_DC_PROGRAM_ID_SUCCESS';
export const COMPACTING_DC_PROGRAM_ID_FAILURE = 'COMPACTING_DC_PROGRAM_ID_FAILURE';

export const FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_REQUEST = 'FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_REQUEST';
export const FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_SUCCESS = 'FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_SUCCESS';
export const FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_FAILURE = 'FETCH_COMPACTING_DC_DETAIL_REPROCESS_PREV_LIST_FAILURE';

export const FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST = 'FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST';
export const FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS = 'FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS';
export const FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE = 'FETCH_COMPACTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE';


export const FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST = 'FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_REQUEST';
export const FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS = 'FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_SUCCESS';
export const FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE = 'FETCH_COMPACTING_DC_DETAILS_DIA_FROM_STYLE_FAILURE';

export const SHOW_PREVIOUS_LIST = 'SHOW_PREVIOUS_LIST';

export const FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_REQUEST = 'FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_REQUEST';

export const FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_SUCCESS = 'FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_SUCCESS';

export const FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_FAILURE = 'FETCH_COMPACTING_DC_FABRIC_STOCK_LIST_FAILURE';
